<template>
	<div class="bg-light min-vh-100 p-4">
		<div class="bg-white p-4 rounded shadow-sm border">
			<!-- KYC Details Section -->
			<div class="mb-4">
				<h2 class="mb-4">KYC Details</h2>
				{{ selectedClientQuote }}
				<div class="row g-3">
					<div class="col-md-6">
						<label class="form-label">KRAPIN</label>
						<input
							v-model="form.krapin"
							type="text"
							class="form-control"
							placeholder="Enter KRAPIN"
							:class="{ 'is-invalid': errors.krapin }"
						/>
						<div v-if="errors.krapin" class="invalid-feedback">
							KRAPIN is required
						</div>
					</div>
					<div class="col-md-6">
						<label class="form-label">Id No.</label>
						<input
							v-model="form.idNo"
							type="text"
							class="form-control"
							placeholder="Enter Id No."
							:class="{ 'is-invalid': errors.idNo }"
						/>
						<div v-if="errors.idNo" class="invalid-feedback">
							Id No. is required
						</div>
					</div>
				</div>
				<div class="mt-3">
					<label class="form-label">Cover Start Date</label>
					<input
						v-model="form.coverStartDate"
						type="date"
						class="form-control"
						placeholder="Enter cover start date"
						:class="{ 'is-invalid': errors.coverStartDate }"
					/>
					<div v-if="errors.coverStartDate" class="invalid-feedback">
						Cover Start Date is required
					</div>
				</div>
			</div>

			<!-- Accept TNC Section -->
			<div class="mb-4">
				<div class="form-check">
					<input
						v-model="form.acceptTnc"
						type="checkbox"
						class="form-check-input"
						id="acceptTnc"
						:class="{ 'is-invalid': errors.acceptTnc }"
					/>
					<label class="form-check-label" for="acceptTnc"
						>Accept TNC</label
					>
					<div v-if="errors.acceptTnc" class="invalid-feedback">
						You must accept the Terms and Conditions
					</div>
				</div>
			</div>

			<!-- Error Message -->
			<div v-if="errorMessage" class="alert alert-danger" role="alert">
				{{ errorMessage }}
			</div>

			<!-- Next Button -->
			<div class="mt-4 text-end">
				<button
					class="btn btn-success d-flex align-items-center ms-auto"
					@click="submitForm"
					:disabled="isLoading"
				>
					<span
						v-if="isLoading"
						class="spinner-border spinner-border-sm me-2"
						role="status"
						aria-hidden="true"
					></span>
					Next <span class="ms-2">→</span>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import clientQuotations from '../rsc/stores/client-quotations';
import { mapGetters, mapActions } from 'vuex';

export default {
	beforeDestroy() {
		this.$store.unregisterModule('clientQuotations');
	},
	created() {
		utils.registerModule('clientQuotations', clientQuotations, this.$store);
	},
	data() {
		return {
			form: {
				krapin: '',
				idNo: '',
				coverStartDate: '',
				acceptTnc: false,
			},
			errors: {
				krapin: false,
				idNo: false,
				coverStartDate: false,
				acceptTnc: false,
			},
			isLoading: false,
			errorMessage: '', // Added to display errors
		};
	},
	computed: {
		...mapGetters(['selectedClientQuote']),
	},
	methods: {
		...mapActions(['createInvoice', 'viewClientQuote']),
		async validateForm() {
			this.errors = {
				krapin: false,
				idNo: false,
				coverStartDate: false,
				acceptTnc: false,
			};

			let isValid = true;

			if (!this.form.krapin.trim()) {
				this.errors.krapin = true;
				isValid = false;
			}
			if (!this.form.idNo.trim()) {
				this.errors.idNo = true;
				isValid = false;
			}
			if (!this.form.coverStartDate.trim()) {
				this.errors.coverStartDate = true;
				isValid = false;
			}
			if (!this.form.acceptTnc) {
				this.errors.acceptTnc = true;
				isValid = false;
			}

			return isValid;
		},
		async submitForm() {
			this.errorMessage = ''; // Reset error message
			if (!(await this.validateForm())) {
				return;
			}

			this.isLoading = true;

			const payload = {
				policyFormref: {
					formData_: {
						terms: this.form.acceptTnc,
						discountCode: '',
						startDate: this.form.coverStartDate,
						termsDownload: 'default',
						krapin: this.form.krapin,
						idNo: this.form.idNo,
						system_quotation_ref:
							this.selectedClientQuote
								.guest_client_quotation_system_ref,
					},
					isValid: async () => this.validateForm(),
				},
			};

			try {
				await this.$store.dispatch('createInvoice', payload);
				this.$router.push({ name: 'NextPage' }); // Adjust route name
			} catch (error) {
				this.errorMessage =
					error.message ||
					'Failed to create invoice. Please try again.';
			} finally {
				this.isLoading = false;
			}
		},
	},
	async mounted() {
		Event.$emit('loader:show', false);
		await this.viewClientQuote();
	},
};
</script>

<style lang="less">
.is-invalid {
	border-color: #dc3545 !important;
}
.invalid-feedback {
	display: block;
	color: #dc3545;
	font-size: 0.875rem;
}
.btn-success:disabled {
	opacity: 0.65;
	cursor: not-allowed;
}
</style>
